import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    Input,
    ElementRef,
    ChangeDetectionStrategy,
    SimpleChange,
    OnChanges,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SuggestionFilter } from '../se-smart-text-editor/suggestion-datasource/suggestion-filter';
import { Suggestion, ExtendedSuggestion } from '../se-smart-text-editor/suggestion-datasource/suggestion';

@Component({
    selector: 'se-suggestion-selector',
    templateUrl: './se-suggestion-selector.component.html',
    styleUrls: ['./se-suggestion-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeSuggestionSelectorComponent implements OnInit, OnChanges {
    @Input() suggestions: Suggestion[];
    @Input() currentFilter: SuggestionFilter;

    @Output() selectedSuggestion = new EventEmitter<ExtendedSuggestion>();
    @Output() preSelectedSuggestionEmitter = new EventEmitter<Suggestion>();
    @Output() closeCommand = new EventEmitter<boolean>();
    preSelectedSuggestion: Suggestion;


    private suggestionText: string = '';
    private suggestionCode: string = '';
    _addingNewText = false;
    _originalSuggestion: Suggestion = new Suggestion();
    _selectedSuggestion: Suggestion = new Suggestion();
    _showEditOrDeleteButton = false;
    _currentSelection: Suggestion;
    _editingView = false;

    constructor(
        private sanitizer: DomSanitizer,
        private elementRef: ElementRef) { }

    ngOnInit() {
        if (this.suggestions) {
            this.preSelectedSuggestion = this.suggestions[0];
            this.preSelectedSuggestionEmitter.emit(this.preSelectedSuggestion);
        }
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        for (const propName of Object.keys(changes)) {
            if (propName === 'suggestions') {
                this.preSelectedSuggestion = this.suggestions[0];
                this.preSelectedSuggestionEmitter.emit(this.preSelectedSuggestion);
            }
        }
    }

    preSelectNext() {
        if (this.suggestions.length > 1 && this.preSelectedSuggestion) {
            const newPreSelectedIndex = (this.suggestions.indexOf(this.preSelectedSuggestion) + 1) % this.suggestions.length;
            this.preSelectedSuggestion = this.suggestions[newPreSelectedIndex];
            this.preSelectedSuggestionEmitter.emit(this.preSelectedSuggestion);
            this.elementRef.nativeElement.querySelector('#suggestion-div-' + newPreSelectedIndex).scrollIntoView();
        }
    }
    preSelectPrevious() {
        if (this.suggestions.length > 1 && this.preSelectedSuggestion) {
            let newPreSelectedIndex = this.suggestions.indexOf(this.preSelectedSuggestion) - 1;
            newPreSelectedIndex = newPreSelectedIndex >= 0 ? newPreSelectedIndex : this.suggestions.length - 1;
            this.preSelectedSuggestion = this.suggestions[newPreSelectedIndex];
            this.preSelectedSuggestionEmitter.emit(this.preSelectedSuggestion);
            this.elementRef.nativeElement.querySelector('#suggestion-div-' + newPreSelectedIndex).scrollIntoView();
        }
    }

    getPreselectedSuggestion(): Suggestion {
        return this.preSelectedSuggestion;
    }

    onSelect(suggestion: Suggestion) {
        /* l'invio dell'evento è ritardato per evitare che eventuali doppi click dell'utente siano propagati al background*/
        if (!this._addingNewText) {
            setTimeout(() => {
                this.selectedSuggestion.emit({ suggestion: suggestion, policy: true });
            }, 150);
        }
    }

    //onSelectExpander(suggestion: Suggestion, event: any) {
    //    // stopProgation per fermare l'evento di "espandi pannello"
    //    event.stopPropagation();
    //    if (!this._addingNewText) {
    //        this.onSelect(suggestion);
    //    }
    //}

    onClose() {
        this.closeCommand.emit(true);
    }

    filterCodeAndText(suggestion: Suggestion) {
        const currentFilter: SuggestionFilter = this.currentFilter;
        this.suggestionText = suggestion.Description ? suggestion.Description : '';
        this.suggestionCode = suggestion.code ? suggestion.code : '';
        const currentFilterTextLower = (currentFilter && currentFilter.text) ? currentFilter.text.toLowerCase() : '';
        const currentFilterText = (currentFilter && currentFilter.text) ? currentFilter.text : '';


        if (this.suggestionText.toLowerCase().startsWith(currentFilterTextLower)) {
            this.suggestionText = '<span style=\'color: #e78914;\'>' + this.suggestionText.substring(0, currentFilterText.length) + '</span>' +
                this.suggestionText.substring(currentFilterText.length, this.suggestionText.length);
        }
        if (typeof suggestion.code !== 'undefined' && suggestion.code) {
            this.suggestionCode = suggestion.code;
            if (this.suggestionCode.toLowerCase().startsWith(currentFilterTextLower)) {
                this.suggestionCode = '<span style=\'color: #e78914;\'>' + this.suggestionCode.substring(0, currentFilterText.length) + '</span>'
                    + this.suggestionCode.substring(currentFilterText.length, this.suggestionText.length);
            }
            this.suggestionCode = '[' + this.suggestionCode + ']';
        }
    }

    /* part of the suggestion is highlighted if match with the current filter */
    createSuggestionHTML(suggestion: Suggestion, index: number) {
        this.filterCodeAndText(suggestion);
        return this.sanitizer.bypassSecurityTrustHtml(index + '. ' + this.suggestionCode + ' ' + this.suggestionText);
    }


  
}
